import React from 'react';
import { resolveScopeLabel } from './scopeUtils';

/** Parse inline **bold** in a line and return React nodes */
export function renderLineWithBold(line) {
    const parts = line.split('**');
    if (parts.length === 1) return line;
    return parts.map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : part));
}

/** Parse a message line: replace {{type:id}} with scope chips, keep **bold**. Returns React nodes. */
export function renderMessageLine(line, classes, students, lineKey) {
    const segments = line.split(/(\{\{\w+:[^}]+\}\})/g);
    return segments.map((seg, i) => {
        const m = seg.match(/^\{\{(\w+):([^}]+)\}\}$/);
        if (m) {
            const [, type, id] = m;
            const label = resolveScopeLabel(type, id, classes, students);
            return (
                <span key={`${lineKey}-${i}`} className="ai-chat-inline-scope">
                    {label}
                </span>
            );
        }
        return <span key={`${lineKey}-${i}`}>{renderLineWithBold(seg)}</span>;
    });
}
